module.exports = __webpack_public_path__ + "static/media/Slider1.ebc3c01d.png";